import { useEffect } from "react";
import { ExtractedContract, RentRollItem, VerificationResult } from "../../types/contract";

export const useVerification = (
  generalContracts: ExtractedContract[],
  rentRollData: RentRollItem[],
  setUnmatchedContractIds: (ids: Set<number>) => void,
  setVerificationResult: (result: VerificationResult | null) => void
) => {
  // レントロール検証処理
  useEffect(() => {
    if (rentRollData.length > 0) {
      const unmatched_contracts = generalContracts.filter((contract) => {
        if (
          !contract.property_name ||
          !contract.room_name ||
          !contract.lessee_name
        )
          return true;
        return !rentRollData.some(
          (rentRollItem) =>
            rentRollItem.property_name === contract.property_name &&
            rentRollItem.room_name === contract.room_name &&
            rentRollItem.lessee_name === contract.lessee_name
        );
      });
      const newUnmatchedIds = new Set(
        unmatched_contracts
          .map((c) => c.id)
          .filter((id): id is number => id !== undefined)
      );
      setUnmatchedContractIds(newUnmatchedIds);
      const missing_documents: VerificationResult["missing_documents"] = [];
      const requiredDocTypes = ["賃貸借契約書", "重要事項説明書"];
      rentRollData.forEach((rentRollItem) => {
        const foundDocs = new Set<string>();
        generalContracts.forEach((contract) => {
          if (
            rentRollItem.property_name === contract.property_name &&
            rentRollItem.room_name === contract.room_name &&
            rentRollItem.lessee_name === contract.lessee_name &&
            contract.document_type
          ) {
            foundDocs.add(
              contract.document_type.replace("重説", "重要事項説明書")
            );
          }
        });
        const missingForThisItem = requiredDocTypes.filter(
          (doc) => !foundDocs.has(doc)
        );
        if (missingForThisItem.length > 0) {
          missing_documents.push({
            property_name: rentRollItem.property_name,
            room_name: rentRollItem.room_name,
            lessee_name: rentRollItem.lessee_name,
            missing_documents: missingForThisItem,
          });
        }
      });
      setVerificationResult({ unmatched_contracts, missing_documents });
    } else {
      setUnmatchedContractIds(new Set());
      setVerificationResult(null);
    }
  }, [generalContracts, rentRollData, setUnmatchedContractIds, setVerificationResult]);
};